export const getInfoIconClickedProps = () => {
    return {
        infoIconContext: 'info_icon_context'
    };
};
